import { UUID_REGEX } from "@bindery/shared/auth/authConstants";
import { DOM_REPLAY_MAX_CHUNKS } from "@bindery/shared/contracts/orientation-capture";
import * as z from "zod";
import { ORIENTATION_API_PREFIX } from "./errors";

export const DOM_REPLAY_PATH = `${ORIENTATION_API_PREFIX}/capture/dom-replay`;

// rrweb's eventWithTime. The Worker checks the envelope only; what it
// stores is this parsed shape re-serialized, never the raw request body.
const replayEventSchema = z.looseObject({
  type: z.number().int(),
  timestamp: z.number(),
  data: z.unknown(),
});
export type DomReplayEvent = z.infer<typeof replayEventSchema>;

export const domReplayChunkRequestSchema = z.strictObject({
  sessionId: z.string().regex(UUID_REGEX),
  captureId: z.string().regex(UUID_REGEX).toLowerCase(),
  seq: z
    .number()
    .int()
    .min(0)
    .max(DOM_REPLAY_MAX_CHUNKS - 1),
  startedAt: z.number(),
  endedAt: z.number(),
  /** Events this capture dropped so far at a cap. */
  droppedEvents: z.number().int().min(0),
  events: z.array(replayEventSchema).min(1),
});
export type DomReplayChunkRequest = z.input<typeof domReplayChunkRequestSchema>;

export const domReplayChunkResponseSchema = z.object({
  stored: z.literal(true),
});
export type DomReplayChunkResponse = z.infer<
  typeof domReplayChunkResponseSchema
>;
